(function () {
  const SELECTOR = 'slideshow-component[data-slide-effect="fade"]';
  const FADE_MS = 300;

  function disableDawnSlideLogic(component) {
    if (typeof component.pause === 'function') {
      component.pause();
    }

    if (component.autoplay) {
      clearInterval(component.autoplay);
      component.autoplay = null;
    }

    if (component.slider) {
      component.slider.scrollLeft = 0;
      component.slider.addEventListener(
        'scroll',
        () => {
          component.slider.scrollLeft = 0;
        },
        { passive: true }
      );
    }

    component.setSlideVisibility = () => {};
    component.update = () => {};
    component.setSlidePosition = () => {};
    component.autoRotateSlides = () => {};
  }

  function initFadeSlideshow(component) {
    if (component.dataset.fadeInitialized === 'true') return;

    const slider = component.querySelector('[id^="Slider-"]');
    if (!slider) return;

    const slides = [...slider.querySelectorAll('.slideshow__slide')];
    if (slides.length === 0) return;

    disableDawnSlideLogic(component);

    component.dataset.fadeInitialized = 'true';

    let currentIndex = slides.findIndex((slide) => slide.classList.contains('slideshow__slide--active'));
    if (currentIndex < 0) currentIndex = 0;

    let isTransitioning = false;
    let autoplayTimer = null;
    let autoplayEnabled = slider.dataset.autoplay === 'true';
    const autoplayDelay = Number(slider.dataset.speed || 5) * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateControls(index) {
      component.querySelectorAll('.slider-counter__link').forEach((link, i) => {
        const isActive = i === index;
        link.classList.toggle('slider-counter__link--active', isActive);
        link.toggleAttribute('aria-current', isActive);
      });

      component.querySelectorAll('.slider-counter--current').forEach((node) => {
        node.textContent = String(index + 1);
      });
    }

    function setSlideAccessibility(index) {
      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }

        slide.querySelectorAll('a, button').forEach((el) => {
          if (isActive) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });
    }

    function finishTransition(outgoing, incoming, nextIndex) {
      outgoing.classList.remove('slideshow__slide--active', 'slideshow__slide--leaving');
      incoming.classList.add('slideshow__slide--active');
      incoming.classList.remove('slideshow__slide--leaving');
      currentIndex = nextIndex;
      isTransitioning = false;
      setSlideAccessibility(currentIndex);
      updateControls(currentIndex);

      if (autoplayEnabled) {
        startAutoplay();
      }
    }

    function goTo(nextIndex) {
      if (nextIndex === currentIndex || isTransitioning) return;
      if (nextIndex < 0) nextIndex = slides.length - 1;
      if (nextIndex >= slides.length) nextIndex = 0;

      stopAutoplay();

      const outgoing = slides[currentIndex];
      const incoming = slides[nextIndex];

      isTransitioning = true;
      updateControls(nextIndex);

      incoming.classList.add('slideshow__slide--active');
      setSlideAccessibility(nextIndex);

      if (reducedMotion || currentIndex === nextIndex) {
        finishTransition(outgoing, incoming, nextIndex);
        return;
      }

      outgoing.classList.add('slideshow__slide--leaving');

      let finished = false;

      const onDone = (event) => {
        if (event.propertyName !== 'opacity') return;
        if (finished) return;
        finished = true;
        outgoing.removeEventListener('transitionend', onDone);
        finishTransition(outgoing, incoming, nextIndex);
      };

      outgoing.addEventListener('transitionend', onDone);

      window.setTimeout(() => {
        if (finished) return;
        finished = true;
        outgoing.removeEventListener('transitionend', onDone);
        finishTransition(outgoing, incoming, nextIndex);
      }, FADE_MS + 100);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length < 2) return;

      autoplayTimer = window.setInterval(() => {
        goTo(currentIndex + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function onPrevNext(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (event.currentTarget.name === 'previous') {
        goTo(currentIndex - 1);
      } else {
        goTo(currentIndex + 1);
      }
    }

    function onDotClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const links = [...component.querySelectorAll('.slider-counter__link')];
      const index = links.indexOf(event.currentTarget);
      if (index >= 0) goTo(index);
    }

    component.querySelectorAll('.slider-button--prev, .slider-button--next').forEach((button) => {
      button.addEventListener('click', onPrevNext, true);
    });

    component.querySelectorAll('.slider-counter__link').forEach((link) => {
      link.addEventListener('click', onDotClick, true);
    });

    const autoplayButton = component.querySelector('.slideshow__autoplay');
    if (autoplayButton) {
      autoplayButton.addEventListener(
        'click',
        (event) => {
          event.stopImmediatePropagation();
          autoplayEnabled = !autoplayEnabled;
          autoplayButton.classList.toggle('slideshow__autoplay--paused', !autoplayEnabled);

          if (autoplayEnabled) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        },
        true
      );
    }

    component.addEventListener('mouseenter', stopAutoplay);
    component.addEventListener('mouseleave', () => {
      if (autoplayEnabled) startAutoplay();
    });

    slides.forEach((slide, i) => {
      slide.classList.toggle('slideshow__slide--active', i === currentIndex);
    });

    setSlideAccessibility(currentIndex);
    updateControls(currentIndex);

    if (autoplayEnabled) {
      startAutoplay();
    }

    // Used by the theme editor: show a slide at once, with no fade, and hold autoplay.
    component.showSlideInEditor = (index) => {
      stopAutoplay();
      slides.forEach((slide, i) => {
        slide.classList.remove('slideshow__slide--leaving');
        slide.classList.toggle('slideshow__slide--active', i === index);
      });
      currentIndex = index;
      isTransitioning = false;
      setSlideAccessibility(index);
      updateControls(index);
    };

    component.resumeAutoplayInEditor = () => {
      if (autoplayEnabled) startAutoplay();
    };
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initFadeSlideshow);
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }
  }

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('slideshow-component').then(boot);
  } else {
    boot();
  }

  /*
   * Theme editor. Editing a slide re-renders the whole section, which replaces
   * the <slideshow-component>, so the new element has to be initialised again
   * and block selection has to be looked up at event time.
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(SELECTOR).forEach(initFadeSlideshow);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const component = event.target.closest?.(SELECTOR);
      if (!component) return;
      initFadeSlideshow(component);
      const slides = [...component.querySelectorAll('.slideshow__slide')];
      const index = slides.indexOf(event.target);
      if (index >= 0 && component.showSlideInEditor) component.showSlideInEditor(index);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const component = event.target.closest?.(SELECTOR);
      if (component && component.resumeAutoplayInEditor) component.resumeAutoplayInEditor();
    });
  }
})();
